import {
  FilterValues, ICategoryType, IDeeplinkFilterParams, IFilterValue, IStreamEndpointParams
} from '@src/types/filters.types'

function parseCategory(categoryParam: string): ICategoryType {
  // convert string numbers to numbers, otherwise return string ('uncategorized')
  return Number(categoryParam) || (categoryParam === 'uncategorized' && categoryParam) || null
}

export function queryParamsToFilterModel(queryParams: IDeeplinkFilterParams): IFilterValue {
  return {
    knowledgeSpaceId: Number(queryParams.space) || null,
    categoryIds: queryParams.categories?.split(',').map(parseCategory) ?? [],
    filter: queryParams.filter?.split(',') as FilterValues[] ?? [ FilterValues.All ],
    topics: queryParams.concepts?.split(',') ?? [],
    includeArchived: queryParams.include_archived === 'true'
  }
}

export function filterModelToQueryParams(filterModel: IFilterValue): IDeeplinkFilterParams {
  const filterString = filterModel.filter.join(',')
  return {
    space: filterModel.knowledgeSpaceId?.toString() || undefined,
    categories: filterModel.categoryIds.join(',') || undefined,
    filter: filterString === FilterValues.All ? undefined : filterString,
    concepts: filterModel.topics.join(',') || undefined,
    include_archived: filterModel.includeArchived ? 'true' : undefined
  }
}

export function queryParamsToStreamEndpointParams(queryParams: IDeeplinkFilterParams): IStreamEndpointParams {
  // check if it includes the 'uncategorized' category
  const include_uncategorized = queryParams.categories?.includes('uncategorized') || undefined
  // remove 'uncategorized' from categories string in order to contain only numeric values
  const categories = queryParams.categories?.split(',')
    .map(parseCategory)
    .filter((category) => category !== 'uncategorized')
    .join(',')

  return {
    query: queryParams.query || queryParams.search,
    knowledgeSpace: Number(queryParams.space) || undefined,
    categories: categories || undefined,
    include_uncategorized,
    filter: queryParams.filter,
    sort: queryParams.sort,
    tags: queryParams.tags?.split(','),
    concepts: queryParams.concepts?.split(','),
    include_archived: queryParams.include_archived === 'true' || undefined
  }
}
